<div class="login-split-container">

    <div class="brand-panel">
        <div class="brand-content">
            <h1>Your partner for
                international recruitment
                and relocations</h1>
            <p>Everything you need in international recruiting. Do it yourself with our products or ask us to do it for
                you.</p>
        </div>

        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
        <div class="shape shape-5"></div>
    </div>


    <div class="login-panel">
        <div class="login-content">

            <button class="btn btn-microsoft" (click)="onLoginClick()">
                <img src="microsoft-logo.svg" alt="Microsoft Logo" class="ms-logo">
                <span>Login</span>
            </button>
        </div>
    </div>
</div>